import React from 'react';
import ReactDOM from 'react-dom/client';
import '@gravity-ui/uikit/styles/styles.css';
import App from './App';
import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { vzhikLogger } from './libs/vzhik-logger/VzhikLogger';
import { INIT_ERRORS_CONFIG } from './constants/INIT_ERRORS_CONFIG';

import { UploadSDK } from '@yandex-int/video-upload-sdk';

UploadSDK.telemetry.configure({
    from: 'vzhik',
});

const DAY_MS = 1000 * 60 * 60 * 24;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DAY_MS,
            cacheTime: DAY_MS,
        },
    },
});

vzhikLogger.initErrors(INIT_ERRORS_CONFIG);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>,
);
